/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Filetoggle_Alwaysdownloadabletooltip5Inputs */

const en_coinvestments_dataroom_filetoggle_alwaysdownloadabletooltip5 = /** @type {(inputs: Coinvestments_Dataroom_Filetoggle_Alwaysdownloadabletooltip5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View-only mode is not available for this file type. `)
};

/**
* | output |
* | --- |
* | "View-only mode is not available for this file type." |
*
* @param {Coinvestments_Dataroom_Filetoggle_Alwaysdownloadabletooltip5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_filetoggle_alwaysdownloadabletooltip5 = /** @type {((inputs?: Coinvestments_Dataroom_Filetoggle_Alwaysdownloadabletooltip5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Filetoggle_Alwaysdownloadabletooltip5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_filetoggle_alwaysdownloadabletooltip5(inputs)
});
export { coinvestments_dataroom_filetoggle_alwaysdownloadabletooltip5 as "coInvestments_dataRoom_fileToggle_alwaysDownloadableTooltip" }